module.exports = __webpack_public_path__ + "static/media/pg10.9d1b4172.jpg";